/*
 * Home Slideshow - Auto-playing hero carousel
 * 6-second interval, fade transitions, dot navigation
 */
(function () {
    var container = document.querySelector('[data-home-slideshow]');
    if (!container) return;

    var slides = container.querySelectorAll('[data-slide]');
    var texts = container.querySelectorAll('[data-slide-text]');
    var dots = container.querySelectorAll('[data-slide-dot]');
    var current = 0;
    var isTransitioning = false;
    var interval = parseInt(container.dataset.homeSlideshow || '6000', 10);
    var timer;

    function goToSlide(index) {
        if (isTransitioning || index === current) return;
        isTransitioning = true;

        // Update slides
        slides.forEach(function (s, i) {
            s.classList.toggle('home-hero__slide--active', i === index);
        });

        // Update text
        texts.forEach(function (t, i) {
            t.classList.toggle('home-hero__text--active', i === index);
        });

        // Update dots
        dots.forEach(function (d, i) {
            d.classList.toggle('home-hero__dot--active', i === index);
        });

        current = index;
        setTimeout(function () { isTransitioning = false; }, 800);
    }

    function nextSlide() {
        goToSlide((current + 1) % slides.length);
    }

    function startAutoplay() {
        timer = setInterval(nextSlide, interval);
    }

    function resetAutoplay() {
        clearInterval(timer);
        startAutoplay();
    }

    // Dot click handlers
    dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
            goToSlide(i);
            resetAutoplay();
        });
    });

    // Initialize first slide
    if (slides.length > 0) {
        slides[0].classList.add('home-hero__slide--active');
        if (texts.length > 0) texts[0].classList.add('home-hero__text--active');
        if (dots.length > 0) dots[0].classList.add('home-hero__dot--active');
    }

    // Start autoplay
    if (slides.length > 1) {
        startAutoplay();
    }
})();
